export default [{
	title: 'Licitaciones',
	icon: 'BookmarkIcon',
	children: [
		{
			title: 'Lista',
			route: 'competitions-list',
			action: 'read',
			resource: 'tenders'
		},
	]
}];